class RIconLottie extends HTMLElement {
  static get observedAttributes() {
    return ['tier'];
  }

  constructor() {
    super();

    this.lottiePlayer = null;
    this.picture = null;
    this.source1x = null;
    this.source2x = null;
    this.img = null;

    this.data = {};
    this.dataNode = null;
    this.tier = (this.getAttribute('tier') || '').toLowerCase();
    this.tierData = null;
    this.configLoaded = false;
  }

  connectedCallback() {
    if (!this.configLoaded) {
      this.loadConfig();
    }

    if (!this.tierData) {
      return;
    }

    this.updateFromTierData();
  }

  loadConfig() {
    this.lottiePlayer = this.querySelector('lottie-player');
    this.picture = this.querySelector('picture');

    if (!this.picture) {
      console.error('No placeholder element found for lottie-player.');
      return;
    }

    const sources = this.picture.querySelectorAll('source');

    this.source1x = sources[0] || null;
    this.source2x = sources[1] || null;
    this.img = this.picture.querySelector('img');

    this.dataNode = document.querySelector('script#r-icon-lottie-data');

    if (!this.lottiePlayer) {
      console.error('No lottie-player element found.');
      return;
    }

    if (!this.dataNode) {
      console.error('No lottie files provided.');
      return;
    }

    try {
      this.data = JSON.parse(this.dataNode.textContent);
    } catch (error) {
      console.error('Failed to parse r-icon-lottie data JSON.', error);
      return;
    }

    this.tierData = this.data[this.tier];

    if (!this.tierData) {
      console.error(`No lottie files found for tier: ${this.tier}`);
      return;
    }

    this.configLoaded = true;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'tier' || oldValue === newValue) return;

    this.tier = (newValue || '').toLowerCase();

    if (!this.configLoaded) {
      this.loadConfig();
    } else {
      this.tierData = this.data[this.tier];
    }

    if (!this.tierData) {
      console.error(`No lottie files found for tier: ${this.tier}`);
      return;
    }

    this.updateFromTierData();
  }

  updateFromTierData() {
    const { lottie, '1x_icon': icon1x, '2x_icon': icon2x } = this.tierData;

    if (this.lottiePlayer.getAttribute('src') !== lottie) {
      const newPlayer = this.lottiePlayer.cloneNode(true);
      newPlayer.setAttribute('src', lottie);
      this.lottiePlayer.replaceWith(newPlayer);
      this.lottiePlayer = newPlayer;
    }

    if (this.source1x.getAttribute('srcset') !== icon1x) {
      this.source1x.setAttribute('srcset', icon1x);
    }

    if (this.source2x.getAttribute('srcset') !== icon2x) {
      this.source2x.setAttribute('srcset', icon2x);
    }

    if (this.img.getAttribute('src') !== icon1x) {
      this.img.setAttribute('src', icon1x);
    }
  }
}
customElements.define('r-icon-lottie', RIconLottie);
